/* import __COLOCATED_TEMPLATE__ from './address-input-field-sublocality-old.hbs.js'; */
var _dec, _class;
import { tagName } from '@ember-decorators/component';
import AddressInputFieldSublocality from './address-input-field-sublocality';
let AddressInputFieldSublocalityOld = (_dec = tagName(''), _dec(_class = class AddressInputFieldSublocalityOld extends AddressInputFieldSublocality {}) || _class);
export { AddressInputFieldSublocalityOld as default };